/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAdmissionFlagsInnerAdmissionFlagAliasesInner } from './LeadAdmissionFlagsInnerAdmissionFlagAliasesInner';
import {
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON,
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped,
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON,
} from './LeadAdmissionFlagsInnerAdmissionFlagAliasesInner';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInnerAdmissionFlag
 */
export interface LeadAdmissionFlagsInnerAdmissionFlag {
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    category: LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    created_at?: string;
    /**
     * 
     * @type {User}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    created_by_user?: User;
    /**
     * 
     * @type {string}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    gender?: string | null;
    /**
     * 
     * @type {Array<LeadAdmissionFlagsInnerAdmissionFlagAliasesInner>}
     * @memberof LeadAdmissionFlagsInnerAdmissionFlag
     */
    aliases?: Array<LeadAdmissionFlagsInnerAdmissionFlagAliasesInner>;
}


/**
 * @export
 */
export const LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum = {
    Behavioral: 'Behavioral',
    Financial: 'Financial',
    Clinical: 'Clinical',
    Other: 'Other'
} as const;
export type LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum = typeof LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum[keyof typeof LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum];


/**
 * Check if a given object implements the LeadAdmissionFlagsInnerAdmissionFlag interface.
 */
export function instanceOfLeadAdmissionFlagsInnerAdmissionFlag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "category" in value;

    return isInstance;
}

export function LeadAdmissionFlagsInnerAdmissionFlagFromJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlag {
    return LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInnerAdmissionFlag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'category': json['category'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : UserFromJSON(json['created_by_user']),
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'aliases': !exists(json, 'aliases') ? undefined : ((json['aliases'] as Array<any>).map(LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON)),
    };
}

export function LeadAdmissionFlagsInnerAdmissionFlagToJSON(value?: LeadAdmissionFlagsInnerAdmissionFlag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'dob': value.dob,
        'category': value.category,
        'comment': value.comment,
        'created_at': value.created_at,
        'created_by_user': UserToJSON(value.created_by_user),
        'gender': value.gender,
        'aliases': value.aliases === undefined ? undefined : ((value.aliases as Array<any>).map(LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON)),
    };
}

